import { render, staticRenderFns } from "./app-header-desktop-menu.vue?vue&type=template&id=e4399b9a&"
import script from "./app-header-desktop-menu.vue?vue&type=script&lang=js&"
export * from "./app-header-desktop-menu.vue?vue&type=script&lang=js&"
import style0 from "./app-header-desktop-menu.vue?vue&type=style&index=0&id=e4399b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports